import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import BootstrapTable from 'react-bootstrap-table-next';
import { updateTitle } from "../../redux/updatePageHeadeSlice";
import { ADMIN_DASHBOARD_HEADER } from "../../constants/headerTitles";
import { useQuery } from "react-query";
import getMonitoringData from "../../api/getAdminMonitoring";
import Loader from '../../pages/utilities/loader';

const MonitoringPage = () => {
    const [globalUsageData, setGlobalUsageData] = useState([])
    const [projectUsageData, setProjectUsageData] = useState([])
    const dispatch = useDispatch()
    const { isLoading, data: monitoringData } = useQuery("getMonitoringData", () => getMonitoringData());

    useEffect(() => {
        dispatch(updateTitle(ADMIN_DASHBOARD_HEADER))
    }, [])

    useEffect(() => {
        if (monitoringData?.data) {
            const tempGlobal = []
            Object.keys(monitoringData?.data[0]).map(project => {
                tempGlobal.push({ ...monitoringData?.data[0][project], project_name: project })
            })
            const tempProject = []
            Object.keys(monitoringData?.data[1]).map(project => {
                tempProject.push({ forms: monitoringData?.data[1][project], project_name: project, })
            })
            // console.log('tempProject', tempProject)
            setGlobalUsageData(tempGlobal)
            setProjectUsageData(tempProject)
        }
    }, [monitoringData?.data])

    const globalUsageColumns = [
        {
            dataField: 'project_name',
            text: 'Projects'
        },
        {
            dataField: 'total_forms',
            text: 'Forms'
        },
        {
            dataField: 'total_keys',
            text: 'Research Key'
        },
        {
            dataField: 'total_documents',
            text: 'Documents'
        },
        {
            dataField: 'total_contributors',
            text: 'Contributors'
        }
    ];

    const projectUsageColumns = [
        {
            dataField: 'project_name',
            text: 'Projects'
        },
        {
            dataField: 'forms',
            text: 'Forms',
            formatter: (data) => {
                return Object.keys(data).map(form => {
                    return <div>{form}</div>
                })
            }
        },
        {
            dataField: 'forms',
            text: 'Columns',
            formatter: (data) => {
                return Object.keys(data).map(form => {
                    return <div>{data[form]?.columns_count}</div>
                })
            }
        },
        {
            dataField: 'forms',
            text: 'Keys',
            formatter: (data) => {
                return Object.keys(data).map(form => {
                    return <div>{data[form]?.research_keys_count}</div>
                })
            }
        },
        {
            dataField: 'forms',
            text: 'Archives',
            formatter: (data) => {
                return Object.keys(data).map(form => {
                    return <div>{data[form]?.archives_count}</div>
                })
            }
        },
        {
            dataField: 'forms',
            text: 'Recycle',
            formatter: (data) => {
                return Object.keys(data).map(form => {
                    return <div>{data[form]?.recycled_count}</div>
                })
            }
        },
        {
            dataField: 'forms',
            text: 'New docs',
            formatter: (data) => {
                return Object.keys(data).map(form => {
                    return <div>{data[form]?.new_docs_count}</div>
                })
            }
        },
        {
            dataField: 'forms',
            text: 'Draft',
            formatter: (data) => {
                return Object.keys(data).map(form => {
                    return <div>{data[form]?.drafts_count}</div>
                })
            }
        },
    ];

    if (isLoading) return <><Loader /></>

    return (
        <>
            <div className="mb-3">
                <div className="wrap-text">
                    <h3>Global Falendi Usage</h3>
                </div>
                <BootstrapTable keyField='project_name' data={globalUsageData} columns={globalUsageColumns} hover />
            </div>
            <div>
                <div className="wrap-text">
                    <h3>Project Usage</h3>
                </div>
                <BootstrapTable keyField='project' data={projectUsageData} columns={projectUsageColumns} hover />
            </div>
        </>
    );
};

export default MonitoringPage;
